export default __webpack_public_path__ + "static/media/Fire-Extinguisher-Price-in-Bangladesh.e14480e2.png";